export default "__VITE_ASSET__BYbz7W5d__"